import React from 'react';
import { useNavigate } from 'react-router-dom';
import CommonAuthComponent from './CommonAuthComponent';
import warningAlertIcon from '/icons/warning-alert.svg';

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    // Remove token from sessionStorage first
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('userInfo');
    // Then navigate to login
    navigate('/login');
  };

  const handleContactSupport = () => {
    // You can customize this to open a support form or redirect to contact page
    // window.open('mailto:support@healthcompass.com', '_blank');
  };

  return (
    <CommonAuthComponent>
      <div className="flex flex-col items-center space-y-6">

        {/* Warning Icon */}
        <div className="flex items-center justify-center bg-white mt-8">
          <img
            src={warningAlertIcon}
            alt="Unauthorized Access"
            className="h-[115px] w-[115px]"
          />
        </div>

        {/* Heading */}
        <h1 className="text-[28px] text-center font-normal text-red-600">
          Access Denied
        </h1>

        {/* Error Code */}
        <div className="text-center">
          <span className="inline-block bg-gray-100 text-gray-600 px-3 py-1 rounded-md text-sm font-mono">
            Error 403 - Forbidden
          </span>
        </div>

        {/* Instruction Text */}
        <div className="text-center leading-relaxed text-[18px] font-normal !mb-4 space-y-2">
          <p>You don't have permission to access this page.</p>
          <p className="text-gray-600 text-base">
            This could be due to insufficient privileges or the resource requiring specific access rights.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col space-y-3 w-full">
          <button
            onClick={handleGoToLogin}
            className="w-full inline-flex rounded-[4px] border transition-all duration-300 text-body-md items-center font-semibold justify-center px-6 py-3.5 bg-REELTeal border border-transparent hover:bg-teal-200 text-white"
          >
            Go to Login
          </button>

          <button
            onClick={handleContactSupport}
            className="w-full inline-flex rounded-[4px] border transition-all duration-300 text-body-md items-center font-semibold justify-center px-6 py-3.5 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700"
          >
            Contact Support
          </button>
        </div>

        {/* Additional Help Text */}
        <div className="text-center text-sm text-gray-500 mt-4">
          <p>If you believe this is an error, please contact your administrator or support team.</p>
        </div>
      </div>
    </CommonAuthComponent>
  );
};

export default Unauthorized; 
